




























export interface iFormDialogOptions {
  title?: string
  confirmText?: string
  confirmFn?: any
  cancelText?: string
  width?: string
  fields?: {
    property?: string
    label?: string
    type?: 'text'
    inputType?: 'text' | 'number' | 'email' | 'phone' | 'time'
    col?: 'is-1' | 'is-2' | 'is-3' | 'is-4' | 'is-5' | 'is-6' | 'is-7' | 'is-8' | 'is-9' | 'is-10' | 'is-11' | 'is-12'
    placeholder?: string
    required?: boolean
    readonly?: boolean
    options?: any[]
    current?: any
    propsMutation?: {
      properties: string[]
      mutation: 'hide' | 'disable'
      conditionFn: Function
    }
  }[]
}

import FormGenerator from './FormGeneration.vue';
export default {
  name: 'form-dialog',
  props: ['options'],
  components: {
    FormGenerator
  },
  data() {
    return {
      errors: {},
      data: {},
      active: false,
      confirming: false,
      success: false
    }
  },
  watch: {
    options: function (val) {
      this.active = !!val
      this.reset()
    }
  },
  mounted() {
    try {
      document.getElementById('modal-form').getElementsByTagName('input').item(0).focus()
    } catch (err) {}
  },
  methods: {
    reset() {
      this.data = {}
      this.errors = {}
      this.confirming = false
      this.success = false
    },
    close() {
      this.active = false
    },
    formChanged(event) {
      this.data = event
    },
    async confirm() {
      if (this.$refs.form.checkErrors()) return
      this.confirming = true
        try {
          await this.options.confirmFn(this.data)
          this.success = true
          setTimeout(() => {
            this.active = false
          }, 1000)
        } catch (err) {
          this.success = false
        } finally {
          this.confirming = false
        }
    }
  }
}
